import Repository from "@shared/services/api/abstracts/Repository";
import { venueBasedUrl } from "@shared/services/api/utils/RepositoryUrlUtils";
import {
  Identifier,
  UrlInjectionMap,
  UrlRouteMap,
} from "@shared/services/api/types";
import { AxiosRequestConfig } from "axios";
import {
  VenueBasedProductRevenueSerializerType,
  VenueBasedProductSerializer,
} from "../types";

export default class VenueBasedProductsRepository extends Repository<VenueBasedProductSerializer> {
  public readonly repositoryName = "VenueBasedProductsRepository";

  public readonly endpoint = venueBasedUrl("products/");

  public get urlMap(): UrlRouteMap {
    return {
      ...this.defaultUrlMap,
      statsRevenue: `{productId}/stats/revenue/`,
    };
  }

  public async statsRevenue(
    productId: Identifier,
    config?: AxiosRequestConfig
  ): Promise<VenueBasedProductRevenueSerializerType[]> {
    const injects: UrlInjectionMap = {};
    injects[this.primaryKey] = productId ?? this.injects[this.primaryKey];

    const { data } = await this.request<
      VenueBasedProductRevenueSerializerType[]
    >(this.buildUrl("statsRevenue", injects), config);

    return data;
  }
}
